import Button from 'common/components/button'
import Modal from 'common/components/Modal'

type Props = {
  isOpen: boolean
  onClose: () => void
}

const LegacyDuplicateWorkflowModal = ({ isOpen, onClose }: Props) => {
  if (!isOpen) {
    return null
  }

  return (
    <Modal
      visible={true}
      centered
      closable={true}
      footer={null}
      onClose={onClose}
      data-testid="legacy-duplicate-workflow-modal"
      style={{ minWidth: 560 }}
    >
      <div className="flex w-full">
        <h1 className="mt-2 text-2xl font-bold text-coolGray-800">
          Legacy campaigns
        </h1>
      </div>
      <div className="mt-2 pr-8">
        <p className="text-sm font-medium text-coolGray-800">
          It's not currently possible to duplicate legacy campaigns. You can
          create a new campaign in the usual way.
        </p>
        <div className="flex justify-end mt-8">
          <Button
            variant="primary"
            onClick={onClose}
            data-testid="legacy-duplicate-workflow-modal-ok-button"
          >
            Ok
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default LegacyDuplicateWorkflowModal
